import api from '@/services/api/auth';
import { useState } from 'react'
import { immerable } from "immer"

class AuthLogin {

	[immerable] = true

	constructor(params) {
		this.authUrl = params.authUrl
		this.domains = params.domains
	}
}

const useAuthLogin = () => {
	const [authError, setAuthError] = useState()
	const [authLoginData, setAuthLoginData] = useState(null)

	async function getAuthorizationURL(parameter) {
		const [authError, response] = await api.create(parameter);

		if (authError) {
			return setAuthError( authError);
		}

		const serializedData = serialize(response?.sso)
		const newItems = new AuthLogin(serializedData)

		setAuthLoginData(newItems)
		return response
	}

	function serialize(entry) {
		return {
			authUrl: entry.authUrl,
			domains: entry.domains
		}
	}

	return {
		authError,
		getAuthorizationURL,
		authLoginData
	}
}

export default useAuthLogin
